const contentSlider = document.querySelectorAll<HTMLElement>('.content-slider');
contentSlider.forEach((slider) => {
	new (window as Window).Swiper(slider, {
		spaceBetween: 20,
		effect: 'fade',
		speed: 600,
		autoplay: {
			delay: 5500,
			disableOnInteraction: false,
		},
		fadeEffect: {
			crossFade: true,
		},
		pagination: {
			el: '.content-slider__paginator',
			clickable: true,
		},
		breakpoints: {
			300: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 1,
			},
		},
	});
});
